import Vue from 'vue'
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core'
// 引入图表，图表后缀都为 Chart
import {
  LineChart, BarChart, PieChart, GaugeChart
} from 'echarts/charts'
// 引入提示框，标题，直角坐标系等组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent, LegendComponent, ToolboxComponent, PolarComponent
} from 'echarts/components'
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import {
  CanvasRenderer
} from 'echarts/renderers'

// 注册必须的组件
echarts.use(TitleComponent) /* 提示框 */
echarts.use(TooltipComponent)
echarts.use(GridComponent)
echarts.use(LegendComponent)
echarts.use(ToolboxComponent)

echarts.use(LineChart)
echarts.use(BarChart)
echarts.use(PieChart)

echarts.use(CanvasRenderer)
echarts.use(GaugeChart)
echarts.use(PolarComponent)

Vue.prototype.$echarts = echarts
